import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../utils/axios';
import CampusMinistryDetails from '../components/CampusMinistryDetails';
import { Container, CircularProgress, Alert, Button, Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const CampusMinistryViewerPage = () => {
  const { registrationId } = useParams();
  const navigate = useNavigate();
  const [registration, setRegistration] = useState(null);
  const [initialLoading, setInitialLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchRegistration = useCallback(async () => {
    setInitialLoading(true);
    setError(null);
    try {
      const response = await axios.get(`/campus-ministry/${registrationId}`);
      setRegistration(response.data);
    } catch (err) {
      console.error('Error fetching Campus Ministry registration:', err);
      setError(`Failed to load registration data. ${err.response?.data?.message || err.message}`);
    }
    setInitialLoading(false);
  }, [registrationId]);

  useEffect(() => {
    if (registrationId) {
      fetchRegistration();
    }
  }, [registrationId, fetchRegistration]);

  if (initialLoading) {
    return (
      <Container sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (error) {
    return (
      <Container sx={{ mt: 4 }}>
        <Alert severity="error" action={
          <Button color="inherit" size="small" onClick={fetchRegistration}>RETRY</Button>
        }>
          {error}
        </Alert>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/campus-ministry')}
          sx={{ mt: 2 }}
        >
          Back to List
        </Button>
      </Container>
    );
  }

  if (!registration) {
    return (
      <Container sx={{ mt: 4 }}>
        <Alert severity="warning">Registration not found.</Alert>
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/campus-ministry')}
          sx={{ mt: 2 }}
        >
          Back to List
        </Button>
      </Container>
    );
  }

  return (
    <Box>
      <CampusMinistryDetails
        registration={registration}
        open={true}
        onClose={() => navigate('/campus-ministry')}
        onUpdate={fetchRegistration}
      />
    </Box>
  );
};

export default CampusMinistryViewerPage;
